var Education = "Образование";
var Enterprise = "Корпоративная";
var CompanyType = {
	"Company type": "Тип компании",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "Государственное учреждение (федерального уровня)",
	"Government - State & local": "Государственное учреждение (регионального и муниципального уровня)",
	"Non-profit": "Некоммерческая организация",
	"Self employed": "Индивидуальный предприниматель",
	"Small-medium business": "Малый и средний бизнес",
	"Start-up": "Стартап",
	"Not applicable": "Не применимо"
};

export { Education, Enterprise, CompanyType as default };
